module.exports = new __parcel__URL__("jira-service-management.ebd870b6.svg").toString();